import { CircularProgress, Flex, Tag, TagLabel, Text, Tooltip } from '@chakra-ui/react'
import { ClinicalRationaleMatch } from '@hb/shared'

interface SuggestedClinicalRationalesProps {
  loading: boolean
  matches: ClinicalRationaleMatch[]
  onMatchClick: (match: ClinicalRationaleMatch) => void
}

export const SuggestedClinicalRationales = ({
  loading,
  matches,
  onMatchClick,
}: SuggestedClinicalRationalesProps) => {
  let body: React.ReactNode = null
  if (loading) {
    body = (
      <Flex align="center" gap={2}>
        <CircularProgress color="green.500" isIndeterminate size={4} />
        <Text fontSize="xs" color="gray.500">
          Generating suggested clinical rationales...
        </Text>
      </Flex>
    )
  } else if (!matches.length) {
    body = (
      <Text fontSize="xs" color="gray.500" fontStyle="italic">
        No suggestions found — please enter the clinical relationship to pregnancy manually.
      </Text>
    )
  } else {
    body = (
      <>
        {matches.map(match => (
          <Tooltip
            key={match.matchedCategoryName}
            label="Click to apply this suggestion"
            hasArrow
            placement="top">
            <Tag
              size="sm"
              cursor="pointer"
              colorScheme={
                match.confidenceScore >= 0.8
                  ? 'green'
                  : match.confidenceScore >= 0.65
                    ? 'blue'
                    : 'orange'
              }
              onClick={() => onMatchClick(match)}
              _hover={{ opacity: 0.8 }}>
              <TagLabel>
                {match.matchedCategoryName} ({Math.round(match.confidenceScore * 100)}%)
              </TagLabel>
            </Tag>
          </Tooltip>
        ))}
      </>
    )
  }

  return (
    <Flex align="center" gap={3} pt={2} flexWrap="wrap">
      <Text fontSize="sm" color="gray.600" flexShrink={0} _dark={{ color: 'gray.400' }}>
        Suggested clinical relationships to pregnancy:
      </Text>
      {body}
    </Flex>
  )
}
